import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = () => {
  const { isLoggedIn } = useAuth();
  const userType = localStorage.getItem("userType");

  // Added this line to prevent the flash on clicking logout button in admin dashboard
  if (isLoggedIn === undefined) return null;

  return isLoggedIn && (userType === "admin" || userType === "employee" || userType === "employee_admin" || ["coach_admin", "coach_employee", "coach"].includes(userType || "")) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoute;